import React, { useEffect, useState } from 'react'
import './payroll.css'
import { useSelector } from 'react-redux'
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import CurrencyCellRenderer from '../../currency-cell-render/currency-cell-render';
import { currencyCode } from '../../../services/constant';
import { getAllEmployeeSalaryDetails } from '../../../api-services/employee-services';
import { useDispatch } from 'react-redux';
import { setSalary } from '../../../redux/actions/actions';
import AgGridContainer from '../../../componant/gridContainer/gridContainer';


const AdminPayroll = () => {
    const employeeState = useSelector((state: any) => state.allEmployee)
    const dispatch = useDispatch()
    const [rawData, setRawData] = useState<any[]>([])
    const currency = currencyCode()
    useEffect(() => {
        getAllEmployeeSalaryDetails().then((response: any) => {
            if (response?.data.success) {
                setRawData(response.data.payload)
                dispatch(setSalary(response.data.payload))
            }
        })
    }, [])
    useEffect(() => {
        if (employeeState.salary.length > 0) {
            setRawData(employeeState.salary)
        }
    }, [employeeState])

    const columnDefs = [
        {
            headerName: "ID",
            field: "employee_id",
            width: 150,
            resizable: true,
            filter: true,
        },
        {
            headerName: "Name",
            field: "name",
            width: 225,
            resizable: true,
            filter: true,
        },
        {
            headerName: "Designation",
            field: "designation",
            width: 275,
            resizable: true,
            filter: true,
        },
        {
            headerName: "Gross Salary",
            field: "grossSalary",
            width: 150,
            resizable: true,
            filter: true,
            cellRenderer: (params: any) => (
                <CurrencyCellRenderer value={params.value} currencyCode={currency} />
            ),
        },
        {
            headerName: "Basic Salary",
            field: "basicSalary",
            width: 150,
            resizable: true,
            filter: true,
            cellRenderer: (params: any) => (
                <CurrencyCellRenderer value={params.value} currencyCode={currency} />
            ),
        },
        {
            headerName: "House Rent Allowance",
            field: "houseRentAllowance",
            width: 175,
            resizable: true,
            filter: true,
            cellRenderer: (params: any) => (
                <CurrencyCellRenderer value={params.value} currencyCode={currency} />
            ),
        },
        {
            headerName: "Dearness Allowance",
            field: "dearnessAllowance",
            width: 175,
            resizable: true,
            filter: true,
            cellRenderer: (params: any) => (
                <CurrencyCellRenderer value={params.value} currencyCode={currency} />
            ),
        },
        {
            headerName: "Travel Allowance",
            field: "travelAllowance",
            width: 150,
            resizable: true,
            filter: true,
            cellRenderer: (params: any) => (
                <CurrencyCellRenderer value={params.value} currencyCode={currency} />
            ),
        },
        {
            headerName: "Medical Allowance",
            field: "medicalAllowance",
            width: 175,
            resizable: true,
            filter: true,
            cellRenderer: (params: any) => (
                <CurrencyCellRenderer value={params.value} currencyCode={currency} />
            ),
        },
        {
            headerName: "Special Allowance",
            field: "specialAllowance",
            width: 175,
            resizable: true,
            filter: true,
            cellRenderer: (params: any) => (
                <CurrencyCellRenderer value={params.value} currencyCode={currency} />
            ),
        },
        {
            headerName: "Income Tax",
            field: "incomeTax",
            width: 150,
            resizable: true,
            filter: true,
            cellRenderer: (params: any) => (
                <CurrencyCellRenderer value={params.value} currencyCode={currency} />
            ),
        },
        {
            headerName: "Professional Tax",
            field: "professionalTax",
            width: 175,
            resizable: true,
            filter: true,
            cellRenderer: (params: any) => (
                <CurrencyCellRenderer value={params.value} currencyCode={currency} />
            ),
        },
        {
            headerName: "Provident Fund",
            field: "providentFund",
            width: 175,
            resizable: true,
            filter: true,
            cellRenderer: (params: any) => (
                <CurrencyCellRenderer value={params.value} currencyCode={currency} />
            ),
        },
        {
            headerName: "Employee State Insurance",
            field: "employeeStateInsurance",
            width: 200,
            resizable: true,
            filter: true,
            cellRenderer: (params: any) => (
                <CurrencyCellRenderer value={params.value} currencyCode={currency} />
            ),
        },
        {
            headerName: "Deduction Ammount",
            field: "deductionAmount",
            width: 200,
            resizable: true,
            filter: true,
            cellRenderer: (params: any) => (
                <CurrencyCellRenderer value={params.value} currencyCode={currency} />
            ),
        },
        {
            headerName: "Net Salary",
            field: "netSalary",
            width: 200,
            filter: true,
            cellRenderer: (params: any) => (
                <CurrencyCellRenderer value={params.value} currencyCode={currency} />
            ),
        }
    ]

    return (
        <>
            <div className='main'>
                <div className='main-container'>
                    <div className='heading heading-start-center height-40'>
                        <h2>Payroll</h2>
                    </div>
                    <div className='cal-40'>

                        <div className='wraper'>
                            <AgGridContainer rowData={rawData} columnDefs={columnDefs} />
                        </div>
                    </div>

                </div>
            </div>

        </>
    )
}

export default AdminPayroll


